enum SwitchSize {
  small = 1,
  medium,
}

type SwitchProps = {
  size: SwitchSize;
  label?: string;
  isSelected: boolean;
  onSelect: () => void | React.Dispatch<React.SetStateAction<any>>;
};

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=3006-1617&t=3lunUvpzgaQBTI5S-4
const Switch = (props: SwitchProps) => {
  const { size, label, isSelected, onSelect } = props;

  return (
    <div className="switch" onClick={onSelect}>
      <div
        className={`switch-toggle ${size == SwitchSize.small ? "small" : "medium"}
      ${isSelected ? "selected" : ""}`}
      >
        <div className={`switch-toggle-circle ${isSelected ? "selected" : ""}`} />
      </div>
      {label && <span className="switch-label">{label}</span>}
    </div>
  );
};

export { Switch, SwitchSize };
